import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/tired': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 456C137.7 456 48 366.3 48 256S137.7 56 248 56 448 145.7 448 256 358.3 456 248 456zM377.1 152.2C373.3 147.8 366.8 146.8 361.8 149.7L281.8 197.7C278.2 199.9 276 203.8 276 208S278.2 216.1 281.8 218.3L361.8 266.3C367.2 269.5 373.6 267.9 377.1 263.8 380.9 259.3 381 252.8 377.2 248.3L343.6 208 377.2 167.7C381 163.2 380.9 156.6 377.1 152.2zM220 208C220 203.8 217.8 199.9 214.2 197.7L134.2 149.7C129.2 146.7 122.7 147.8 118.9 152.2 115.1 156.7 115 163.2 118.8 167.7L152.4 208 118.8 248.3C115 252.8 115.1 259.3 118.9 263.8 122.4 267.9 128.8 269.5 134.2 266.3L214.2 218.3C217.8 216.1 220 212.2 220 208zM248 272C202.6 272 147.1 310.3 140.2 365.3 138.7 377.1 147.1 386.9 155.7 383.2 178.4 373.5 212 368 248 368S317.6 373.5 340.3 383.2C348.8 386.9 357.3 377.2 355.8 365.3 348.9 310.3 293.4 272 248 272z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/tired.js
// module id = 3wGh
// module chunks = 144